import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { BiCalendar } from "react-icons/bi";
import { FaList, FaCog, FaFile, FaFileAlt, FaCube } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import {
  BsSearch,
  BsList,
  BsChatDots,
  BsBell,
  BsGear,
  BsPower,
} from "react-icons/bs";

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showComponentsSubMenu, setShowComponentsSubMenu] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [contentWidth, setContentWidth] = useState("");
  const [showEPICX, setShowEPICX] = useState(true);

  const [sidebarWidth, setSidebarWidth] = useState("220px"); // Default width of the sidebar

  useEffect(() => {
    // Check if the current path is either "/assets" or "/forms"
    if (location.pathname === "/assets" || location.pathname === "/forms") {
      // If it is, set showComponentsSubMenu to true
      setShowComponentsSubMenu(true);
    } else {
      // Otherwise, set it to false
      setShowComponentsSubMenu(false);
    }
  }, [location.pathname]);

  const handleClick = () => {
    navigate("/Contact");
  };

  const toggleSidebar = () => {
    if (!sidebarCollapsed && sidebarWidth !== "55px") {
      setSidebarWidth("55px");
      setContentWidth("96%");
    } else {
      setSidebarWidth("220px");
      setContentWidth("50%");
    }

    if (!sidebarCollapsed) {
      setShowEPICX(false); // Hide EPICX when collapsing sidebar
      setSidebarCollapsed(true);
      // Additional logic for sidebar width adjustment if needed
    } else {
      setShowEPICX(true); // Show EPICX when expanding sidebar
      setSidebarCollapsed(false);
      // Additional logic for sidebar width adjustment if needed
    }
  };

  const handleLogout = () => {
    navigate("/login");
  };

  return (
    <>
    <nav
      className={` d-md-block sidebar bg-white border-right border-right-black ${sidebarCollapsed ? "collapsed" : ""}`}
      style={{
        minWidth: sidebarWidth,
        maxWidth: sidebarWidth,
        height: "100vh",
        overflow: "hidden",
        overflowY: "auto",
      }}
    >
      <div className="position-sticky" style={{marginTop:'70px'}}>
        
        <ul className="nav flex-column">
          <li className="nav-item mb-2">
            <div
              className="nav-link text-dark font-family-inter font-size-16 d-flex align-items-center"
              style={{ cursor: "pointer" }}
              onClick={() => {
                console.log("Navigating to /template");
                navigate("/dashboard");
              }}
            >
              <img
                src="images/Dashboard Icon.svg"
                alt="Dashboard Icon"
                className="mr-md-3 mr-1"
                style={{ width: "26px", height: "26px" }}
              />
              <span>Dashboard</span>
            </div>
          </li>

          <li className="nav-item mb-2">
            <div
              className="nav-link text-dark font-family-inter font-size-16"
              style={{ cursor: "pointer" }}
            >
              <BiCalendar
                className="mr-md-4 mr-2"
                style={{ fontSize: "1.5rem", color: "#64748B" }}
              />
              Calendar
            </div>
          </li>

          <li className="nav-item mb-2">
            <div
              className="nav-link text-dark font-family-inter font-size-16"
              style={{ cursor: "pointer" }}
              onClick={handleClick}
            >
              <img
                src="images/Contacts Icon.svg"
                alt="Contacts Icon"
                className="mr-md-4 mr-2"
                style={{ width: "26px", height: "26px" }}
              />
              Contacts
            </div>
          </li>

          <li className="nav-item mb-2">
            <div
              className="nav-link text-dark font-family-inter font-size-16 d-flex align-items-center"
              style={{ cursor: "pointer" }}
              onClick={() => {
                console.log("Navigating to /segment");
                navigate("/segment");
              }}
            >
              <div style={{ color: "#64748B", marginRight: "27px" }}>
                <FaList style={{ fontSize: "1.3rem" }} />
              </div>
              Segments
            </div>
          </li>

          <li className="nav-item mb-2">
            <div
              className="nav-link text-dark font-family-inter font-size-16"
              style={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
              }}
              onClick={() => {
                setShowComponentsSubMenu(!showComponentsSubMenu);
              }}
            >
              <FaCog
                className="mr-md-4 mr-2"
                style={{ fontSize: "1.5rem", color: "#64748B" }}
              />
              <span style={{ marginRight: "10px" }}>Components</span>
            </div>
            {showComponentsSubMenu && (
              <ul className="nav flex-column mt-2 ml-4">
                <li className="nav-item mb-2">
                  <div
                    className="nav-link text-dark font-family-inter font-size-16"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      console.log("Navigating to /assets");
                      navigate("/components");
                    }}
                  >
                    <FaFileAlt
                      className="mr-md-4 mr-2"
                      style={{ fontSize: "1.5rem", color: "#64748B" }}
                    />
                    Assets
                  </div>
                </li>
                <li className="nav-item mb-2">
                  <div
                    className="nav-link text-dark font-family-inter font-size-16"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      console.log("Navigating to /forms");
                      navigate("/formgridpath");
                    }}
                  >
                    <FaFile
                      className="mr-md-4 mr-2"
                      style={{ fontSize: "1.5rem", color: "#64748B" }}
                    />
                    Forms
                  </div>
                </li>
                <li className="nav-item mb-2">
                  <div
                    className="nav-link text-dark font-family-inter font-size-16"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      navigate("/ContentGrid");
                    }}
                  >
                    <FaCube
                      className="mr-md-4 mr-2"
                      style={{ fontSize: "1.5rem", color: "#64748B" }}
                    />
                    Dynamic Content
                  </div>
                </li>
              </ul>
            )}
          </li>

          <li className="nav-item mb-2">
            <div
              className="nav-link text-dark font-family-inter font-size-16"
              style={{ cursor: "pointer" }}
              onClick={() => {
                console.log("Navigating to /fileimage");
                navigate("/campaignbuilder");
              }}
            >
              <img
                src="images/Email Announcement Icon.svg"
                alt="Email Icon"
                className="mr-md-4 mr-2"
                style={{ width: "26px", height: "26px" }}
              />
              Campaign
            </div>
          </li>

          <li className="nav-item mb-2">
            <div
              className="nav-link text-dark font-family-inter font-size-16 d-flex align-items-center"
              style={{ cursor: "pointer" }}
              onClick={() => {
                console.log("Navigating to /fileimage");
                navigate("/fileimage");
              }}
            >
              <div style={{ color: "#64748B", marginRight: "20px" }}>
                <img
                  src="images/Library Icon.svg"
                  alt="Templates Icon"
                  style={{ width: "26px", height: "26px" }}
                />
              </div>
              Templates
            </div>
          </li>

          <li className="nav-item mb-2">
            <div
              className="nav-link text-dark font-family-inter font-size-16"
              style={{ cursor: "pointer" }}
            >
              <img
                src="images/Report Icon.svg"
                alt="Report Icon"
                className="mr-md-4 mr-2"
                style={{ width: "26px", height: "26px" }}
              />
              Reports
            </div>
          </li>

          <li className="nav-item mb-2">
            <div
              className="nav-link text-dark font-family-inter font-size-16"
              style={{ cursor: "pointer" }}
            >
              <img
                src="images/Settings Icon.svg"
                alt="Settings Icon"
                className="mr-md-4 mr-2"
                style={{ width: "26px", height: "26px" }}
              />
              Settings
            </div>
          </li>
        </ul>
      </div>
    </nav>

{/* Top Bar NAv */}

     <div className="bg-white" style={{ height:'50px',position:'fixed',top:'0',zIndex:'10',right:0,width:'100%' }}>
     <div className="d-flex align-items-center text-dark">
     <div className="ml-3">
          <div className="font-weight-bold d-flex gap-4 align-items-center">
            <img
              src="/images/EPICX.jpeg"
              alt="" // Empty string for decorative image
              style={{
                width: "50px",
                height: "50px",
                background:'white'
              }}
            />
            {!sidebarCollapsed && (
              <>
              <span
                className=""
                style={{
                  backgroundImage:
                    "linear-gradient(to right, #22DBFF, #C43BFF)",
                  WebkitBackgroundClip: "text",
                  color: "transparent",
                  fontSize: "24px",
                }}
              >
                E&nbsp;P&nbsp;I&nbsp;C&nbsp;-&nbsp;X
              </span>
              </>
            )}

            <BsList style={{ fontSize: "30px" }} onClick={toggleSidebar} />
          </div>
        </div>
     

       <div className="input-group w-25 ml-3">
         <div className="input-group-prepend">
           <span className="input-group-text bg-transparent">
             <BsSearch
               className="bi bi-lg"
               style={{ fontSize: "20px" }}
             />
           </span>
         </div>
         <input
           className="form-control text-black"
           placeholder="Search..."
           style={{ fontSize: "14px" }}
         />
       </div>

       <div className="d-flex align-items-center ml-auto">
         <BsChatDots
           className="bi bi-lg mr-md-3"
           style={{ fontSize: "24px" }}
         />
         <BsBell
           className="bi bi-lg mr-md-3"
           style={{ fontSize: "24px" }}
         />
         <BsGear
           className="bi bi-lg mr-md-3"
           style={{ fontSize: "24px" }}
         />
         <div
           className="rounded-circle border border-dark mr-md-3 bi bi-lg"
           style={{ width: "40px", height: "40px", overflow: "hidden" }}
         >
           {/* Your image goes here */}
         </div>
         <span className="font-family-inter font-size-14 text-black mr-md-3">
           Vanithashree
         </span>
         <BsPower
           className="bi bi-lg"
           style={{ fontSize: "24px", cursor: "pointer" }}
           onClick={handleLogout}
         />
       </div>
     </div>
   </div>
   </>
  );
};

export default Sidebar;
